<template>
<div class="chapter">
<div class="inner_page">
<p class="P_Normal__And__Centre_Alignment__And__Left_Indent"><span><span style=" font-style: italic; font-size: 1.17em;">To my Dad</span></span></p>
<p class="P_Normal__And__Centre_Alignment__And__Left_Indent"><span><span style=" font-style: italic; font-size: 1.17em;">Who nightly introduced me to urban fantasy</span></span></p>
<p class="P_Normal__And__Centre_Alignment__And__Left_Indent"><span><span style=" font-style: italic; font-size: 1.17em;">Through magic rings that sent and brought back,</span></span></p>
<p class="P_Normal__And__Centre_Alignment__And__Left_Indent"><span><span style=" font-style: italic; font-size: 1.17em;">A horse that could talk,</span></span></p>
<p class="P_Normal__And__Centre_Alignment__And__Left_Indent"><span><span style=" font-style: italic; font-size: 1.17em;">And a wardrobe that sometimes led between Here and There.</span></span></p>
<p class="P_Normal__And__Centre_Alignment__And__Left_Indent"><span><span style=" font-style: italic; font-size: 1.17em;">- Joshua</span></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0003.vue?329b720a